import * as ko from "knockout";
import {ICustomButton} from "./AbstractHeading";
import {hasher} from 'hasher';
import sub_accordionHtml from './sub-accordion.html?raw';

export let template = sub_accordionHtml;

interface IParams {
    toggle: KnockoutObservable<boolean>
    label: string
    customButtons: ICustomButton[]
    badge: any
}

export class viewModel {
    toggle: KnockoutObservable<boolean>;
    label: string;
    private customButtons: ICustomButton[];
    private badge: any;

    constructor(params: IParams) {
        this.toggle = params.toggle || ko.observable(false);
        this.label = params.label;
        this.customButtons = params.customButtons || [];
        this.badge = params.badge;
    }

    onCustomButtonClick(customButton: ICustomButton) {
        if (customButton.onClick) {
            customButton.onClick();
        } else if(customButton.href) {
            hasher.setHash(customButton.href);
        }
    }

}
